<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    custom-class="service-dialog"
    width="90%"
    @close="handleClose"
  >
    <div class="dialog-header">
      <div class="dialog-top">
        <img :src="require('@/assets/logo-active.png')" alt="亚科Logo" class="dialog-logo">
        <div class="dialog-title">
          {{ getText('serviceDialog.hotline', '免费服务热线：') }}<span> {{currentLanguage !=='zh'?'+86-15062454963':'13451648594'}} </span>
        </div>
      </div>
      <div class="dialog-bottom">
        {{ getText('serviceDialog.description', '请留下您的需求信息，我们将在1个工作日内与您联系') }}
      </div>
    </div>

    <el-form
      ref="serviceForm"
      :model="formData"
      :rules="rules"
      label-position="top"
      class="service-form"
    >
      <el-form-item :label="getText('serviceDialog.form.name', '姓名')" prop="name">
        <el-input
            v-model="formData.name"
            :placeholder="getText('serviceDialog.form.namePlaceholder', '请输入您的姓名')"
        />
      </el-form-item>

      <el-form-item :label="getText('serviceDialog.form.contact', '联系方式')" prop="contact">
        <el-input
            v-model="formData.contact"
            :placeholder="getText('serviceDialog.form.contactPlaceholder', '请输入您的电话/手机号/邮箱')"
        />
      </el-form-item>

      <el-form-item :label="getText('serviceDialog.form.company', '公司名称')" prop="company">
        <el-input
            v-model="formData.company"
            :placeholder="getText('serviceDialog.form.companyPlaceholder', '请输入您的公司名称')"
        />
      </el-form-item>

      <el-form-item :label="getText('serviceDialog.form.service', '服务名称')" prop="service">
        <el-input
            v-model="formData.service"
            :placeholder="getText('serviceDialog.form.servicePlaceholder', '请输入服务名称')"
        />
      </el-form-item>

      <el-form-item :label="getText('serviceDialog.form.requirement', '需求详述')" prop="requirement">
        <el-input
            v-model="formData.requirement"
            type="textarea"
            :rows="4"
            :placeholder="getText('serviceDialog.form.requirementPlaceholder', '请输入您的定制需求')"
        />
      </el-form-item>

      <el-form-item class="form-footer">
        <el-button type="primary" @click="handleSubmit">{{ getText('serviceDialog.form.submit', '提交') }}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { submitProductForm } from '@/api'
import {mapState} from "vuex";

export default {
  name: 'ServiceDialog',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    // 监控 item 数据变化
    item: {
      handler(newVal) {
        if (newVal && newVal.casNo) {
          // 设置 CAS 号默认值
          this.formData.service = newVal.casNo + '-获取样品'
          this.formData.belongs = newVal.belongs
        }
      },
      immediate: true // 组件创建时立即执行一次
    },
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 强制重新渲染组件以更新文本
          this.$forceUpdate()
        }
      },
      immediate: false
    }
  },
  data() {
    return {
      visible: false,
      formData: {
        name: '',
        contact: '',
        company: '',
        service: '',
        requirement: '',
        type: 3,
        belongs: 1
      }
    }
  },

  computed: {
    ...mapState({
      currentLanguage: state => state?.app?.language || 'zh'
    }),
    rules() {
      return {
        name: [
          { required: true, message: this.getText('serviceDialog.validation.nameRequired', '请输入姓名'), trigger: 'blur' }
        ],
        contact: [
          { required: true, message: this.getText('serviceDialog.validation.contactRequired', '请输入联系方式'), trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    // 安全的文本获取方法
    getText(key, fallback) {
      try {
        // 尝试使用 i18n
        if (this.$i18n && this.$i18n.t) {
          return this.$i18n.t(key)
        }
        // 如果 i18n 不可用，返回默认值
        return fallback
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error)
        return fallback
      }
    },

    // 打开弹窗
    show() {
      this.visible = true
    },

    // 关闭弹窗
    handleClose() {
      this.visible = false
      this.$refs.serviceForm.resetFields()
    },

    // 修改提交表单方法
    async handleSubmit() {
      try {
        // 先进行表单验证
        const valid = await this.$refs.serviceForm.validate()
            .catch(error => {
              console.error('表单验证失败:', error)
              return false
            })

        if (!valid) {
          return
        }

        this.$loading.show()
        try {
          // 调用 API 提交表单
          const response = await submitProductForm(this.formData)

          if (response.success) {
            this.$message.success(this.getText('serviceDialog.messages.submitSuccess', '提交成功'))
            this.handleClose()
          } else {
            this.$message.error(response.msg || this.getText('serviceDialog.messages.submitFailed', '提交失败'))
          }
        } finally {
          // 关闭加载状态
          this.$loading.hide()
        }
      } catch (error) {
        console.error('提交表单失败:', error)
        this.$message.error(this.getText('serviceDialog.messages.submitFailedRetry', '提交失败，请稍后重试'))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.service-dialog {
  :deep(.el-dialog) {
    margin: 20px auto !important;
    max-width: 400px;
    border-radius: 12px;
  }

  :deep(.el-dialog__header) {
    display: none;
  }

  /deep/ .el-dialog__body {
    padding: 0 !important;
  }

  .dialog-header {
    padding: 10px 10px 0;
    background: #f8f9fa;
    border-radius: 6px 6px 0 0;

    .dialog-top {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 10px;

      .dialog-logo {
        width: 80px;
        height: auto;
        margin-bottom: 15px;
      }

      .dialog-title {
        font-size: 14px;
        color: #333;
        text-align: center;

        line-height: 1.4;
        
        span {
          color: var(--primary-color);
          font-weight: bold;
        }
      }
    }

    .dialog-bottom {
      font-size: 14px;
      color: #666;
      line-height: 1.5;
      text-align: center;
      padding-bottom: 20px;
    }
  }

  .service-form {
    padding: 10px 0;

    :deep(.el-form-item) {
      margin-bottom: 10px;

      .el-form-item__label {
        padding-bottom: 2px;
        color: #333;
        font-size: 12px;

        line-height: 1.4;
      }

      .el-input__inner {
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        border: 1px solid #e0e0e0;
        font-size: 12px;
        
        &:focus {
          border-color: var(--primary-color);
        }
      }

      .el-textarea__inner {
        padding: 12px;
        border-radius: 8px;
        border: 1px solid #e0e0e0;
        font-size: 14px;
        min-height: 100px;
        
        &:focus {
          border-color: var(--primary-color);
        }
      }
    }

    .form-footer {
      margin-bottom: 0;
      margin-top: 30px;
      text-align: center;
      
      :deep(.el-form-item__content) {
        margin-left: 0 !important;
      }
      
      .el-button {
        width: 100%;
        height: 36px;
        background: var(--primary-color);
        border-color: var(--primary-color);
        font-size: 14px;

        border-radius: 8px;
        
        &:hover {
          background: var(--primary-color);
          border-color: var(--primary-color);
          opacity: 0.9;
        }
        
        &:active {
          background: var(--primary-color);
          border-color: var(--primary-color);
          opacity: 0.8;
        }
      }
    }
  }
}
</style> 